export const CHECKOUT_TEST_ID = {
  subtotal: 'checkout-subtotal',
  discount: 'checkout-discount',
  tax: 'checkout-tax',
  serviceCharge: 'checkout-service-charge',
  tip: 'checkout-tip',
  total: 'checkout-total',
  form: 'checkout-form',
  error: 'checkout-error',
  deliveryFee: 'checkout-delivery-fee',
  surcharge: 'checkout-surcharge',
  leadtime: 'lead-time',
  edit: 'edit',
  merchant_privacy_policy: 'merchant_privacy_policy',
  orderFee: 'checkout-orderfee',
  giftCard: 'checkout-giftCard'
};

export const PAYMENT_INFO_TEST_ID = {
  root: 'payment-input-field'
};

export const GOOGLE_PAY_BUTTON_TEST_ID = {
  root: 'google-pay-button'
};

export const PLACE_ORDER_BUTTON_TEST_ID = {
  root: 'place-order-button'
};

export const PERKS_SECTION = {
  root: 'perks-section'
};
